import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/help/$slug")({
	beforeLoad: ({ params }) => {
		throw redirect({ href: `/docs/${params.slug}` });
	},
});
